import React from 'react';
import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';

const CalendarTimesToggleGroup = ({
  name,
  value,
  length,
  onChange,
  disabled,
}) => {
  return (
    <Stack gap={1}>
      <Typography variant="body2">반복 횟수</Typography>
      <ToggleButtonGroup
        {...{
          color: 'secondary',
          name,
          value,
          onChange,
          exclusive: true,
          disabled: disabled || false,
        }}
        sx={{ width: '100%', '& button': { width: '100%' } }}
      >
        {Array.from({ length }).map((v, i) => (
          <ToggleButton value={i + 1} key={`times${i + 1}`}>
            {`${i + 1}회`}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

export default CalendarTimesToggleGroup;
